import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { schema } from 'normalizr';
import { userSchema, userListSchema } from './user';
import { DeviationResourceType } from '../../../types/deviation';
const getCompositeId = (typeId, deviationId)=>typeId === DeviationResourceType.ART ? deviationId : `${typeId}-${deviationId}`;
const getDeviationEntityId = (value)=>getCompositeId(value.typeId, value.deviationId);
const getDeviationEntityIds = (values)=>values.map(getDeviationEntityId);
const processStrategy = (value)=>{
    return _object_spread_props(_object_spread({}, value), {
        entityId: getDeviationEntityId(value)
    });
};
const deviationSchema = new schema.Entity('deviation', {
    author: userSchema,
    groupDestination: userSchema
}, {
    idAttribute: getDeviationEntityId,
    processStrategy
});
const deviationListSchema = [
    deviationSchema
];
// #region extended deviation
const collectionListSchema = new schema.Array({
    collection: {
        owner: userSchema,
        thumb: deviationSchema
    },
    deviations: deviationListSchema
});
const relatedContentSchema = new schema.Array({
    deviations: deviationListSchema,
    collections: collectionListSchema,
    groups: userListSchema
});
const deviationExtendedSchema = new schema.Entity('deviationExtended', {
    relatedContent: relatedContentSchema,
    exclusiveGroup: userSchema
}, {
    idAttribute: (value, parent, key)=>getCompositeId(parent.typeId, parent.deviationId),
    processStrategy: (value, parent, key)=>_object_spread_props(_object_spread({}, value), {
            parentDeviationEntityId: getCompositeId(parent.typeId, parent.deviationId)
        })
});
// add extended to the deviation schema...
deviationSchema.define({
    extended: deviationExtendedSchema
});
// #endregion
export { deviationSchema, deviationListSchema, deviationExtendedSchema, getDeviationEntityId, getDeviationEntityIds, getCompositeId };
